import {
	GET_DOCUMENT_PAGE_REQUEST,
	GET_DOCUMENT_ROW_CLICK_REQUEST,
	GET_DOCUMENT_REQUEST_SUCCESS,
	GET_DOCUMENT_REQUEST_FAILED,
	GET_DOCUMENT_REQUEST_FAILED_CLEAR,
	UPDATE_DOCUMENT_MODAL_COMMENTS,
	GET_FILE_ROW_CLICK_REQUEST,
	GET_FILE_REQUEST_SUCCESS,
	GET_FILE_REQUEST_FAILED,
	GET_FILE_REQUEST_FAILED_CLEAR,
	GET_FILE_PAGE_REQUEST,
	GET_FILE_PAGE_REQUEST_SUCCESS,
	GET_FILE_PAGE_REQUEST_FAILED,
	RESET_PAGE_VIEWER,
	UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET,
	UPDATE_DOCUMENT_MODAL_REVIEW,
} from "../types"

//cada reducer tiene su propio state
const initialState = {
	currentDocument: {},
	documentDetails: {},
	pageNumberForCurrentDocument: [],
	pageNumberBasedOnHighlightedText: [],
	ispageNumberBasedOnHighlightedTextLoading: false,
	documentLoading: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_DOCUMENT_PAGE_REQUEST:
			return {
				...state,
				documentLoading: true,
				currentDocument: {},
			}
		case GET_DOCUMENT_ROW_CLICK_REQUEST:
			return {
				...state,
				documentLoading: true,
				currentDocument: {},
			}
		case GET_DOCUMENT_REQUEST_SUCCESS:
			return {
				...state,
				documentLoading: false,
				currentDocument: action.payload || {},
			}
		case GET_DOCUMENT_REQUEST_FAILED:
			return {
				...state,
				documentLoading: false,
				documentError: action.payload,
			}
		case GET_DOCUMENT_REQUEST_FAILED_CLEAR:
			return {
				...state,
				documentError: undefined,
			}
		case UPDATE_DOCUMENT_MODAL_COMMENTS:
			const updatedDoc = { ...state.documentDetails }
			if (state.documentDetails.id === action.payload.docId) {
				updatedDoc["comments"] = action.payload.data
				updatedDoc["comments_count"] = action.payload.count
			}
			return {
				...state,
				documentDetails: updatedDoc,
			}
		case UPDATE_DOCUMENT_MODAL_REVIEW:
			const documentDetailsState = { ...state.documentDetails }
			if (state.documentDetails.id === action.payload.reviewFileId) {
				documentDetailsState["reviewed"] = action.payload.status
			}
			return {
				...state,
				documentDetails: documentDetailsState,
			}
		case GET_FILE_ROW_CLICK_REQUEST:
			return {
				...state,
				documentLoading: true,
				documentDetails: {},
			}
		case GET_FILE_REQUEST_SUCCESS:
			return {
				...state,
				documentLoading: false,
				documentDetails: action.payload || {},
			}
		case GET_FILE_REQUEST_FAILED:
			return {
				...state,
				documentLoading: false,
				documentDetails: {},
				documentError: action.payload,
			}
		case GET_FILE_REQUEST_FAILED_CLEAR:
			return {
				...state,
				documentDetails: {},
				documentError: undefined,
			}
		case GET_FILE_PAGE_REQUEST:
			return {
				...state,
				documentLoading: true,
				currentDocument: {},
			}
		case GET_FILE_PAGE_REQUEST_SUCCESS:
			return {
				...state,
				documentLoading: false,
				currentDocument: action.payload || {},
			}
		case GET_FILE_PAGE_REQUEST_FAILED:
			return {
				...state,
				documentLoading: false,
				currentDocument: {},
			}
		case UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT:
			return {
				...state,
				pageNumberForCurrentDocument: action.payload,
				documentLoading: false,
			}
		case GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT:
			return {
				...state,
				ispageNumberBasedOnHighlightedTextLoading: true,
			}
		case GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS:
			return {
				...state,
				pageNumberBasedOnHighlightedText: action?.payload || [],
				ispageNumberBasedOnHighlightedTextLoading: false,
			}
		case GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED:
			return {
				...state,
				ispageNumberBasedOnHighlightedTextLoading: false,
			}
		case GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET:
			return {
				...state,
				pageNumberBasedOnHighlightedText: [],
				ispageNumberBasedOnHighlightedTextLoading: false,
			}
		case RESET_PAGE_VIEWER:
			return {
				...initialState,
			}
		default:
			return state
	}
}
